/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  PrepareEMARequestBody,
  PrepareEMARequestBody$Outbound,
  PrepareEMARequestBody$outboundSchema,
} from "../components/prepareemarequestbody.js";

export type PrepareEMASecurityOption1 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type PrepareEMASecurityOption2 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type PrepareEMASecurity = {
  option1?: PrepareEMASecurityOption1 | undefined;
  option2?: PrepareEMASecurityOption2 | undefined;
};

export type PrepareEMARequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
  prepareEMARequestBody: PrepareEMARequestBody;
};

/** @internal */
export type PrepareEMASecurityOption1$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const PrepareEMASecurityOption1$outboundSchema: z.ZodMiniType<
  PrepareEMASecurityOption1$Outbound,
  PrepareEMASecurityOption1
> = z.pipe(
  z.object({
    projectSlugHeaderGramProject: z.string(),
    sessionHeaderGramSession: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function prepareEMASecurityOption1ToJSON(
  prepareEMASecurityOption1: PrepareEMASecurityOption1,
): string {
  return JSON.stringify(
    PrepareEMASecurityOption1$outboundSchema.parse(prepareEMASecurityOption1),
  );
}

/** @internal */
export type PrepareEMASecurityOption2$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const PrepareEMASecurityOption2$outboundSchema: z.ZodMiniType<
  PrepareEMASecurityOption2$Outbound,
  PrepareEMASecurityOption2
> = z.pipe(
  z.object({
    apikeyHeaderGramKey: z.string(),
    projectSlugHeaderGramProject: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      apikeyHeaderGramKey: "apikey_header_Gram-Key",
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
    });
  }),
);

export function prepareEMASecurityOption2ToJSON(
  prepareEMASecurityOption2: PrepareEMASecurityOption2,
): string {
  return JSON.stringify(
    PrepareEMASecurityOption2$outboundSchema.parse(prepareEMASecurityOption2),
  );
}

/** @internal */
export type PrepareEMASecurity$Outbound = {
  Option1?: PrepareEMASecurityOption1$Outbound | undefined;
  Option2?: PrepareEMASecurityOption2$Outbound | undefined;
};

/** @internal */
export const PrepareEMASecurity$outboundSchema: z.ZodMiniType<
  PrepareEMASecurity$Outbound,
  PrepareEMASecurity
> = z.pipe(
  z.object({
    option1: z.optional(z.lazy(() => PrepareEMASecurityOption1$outboundSchema)),
    option2: z.optional(z.lazy(() => PrepareEMASecurityOption2$outboundSchema)),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
    });
  }),
);

export function prepareEMASecurityToJSON(
  prepareEMASecurity: PrepareEMASecurity,
): string {
  return JSON.stringify(
    PrepareEMASecurity$outboundSchema.parse(prepareEMASecurity),
  );
}

/** @internal */
export type PrepareEMARequest$Outbound = {
  "Gram-Session"?: string | undefined;
  "Gram-Key"?: string | undefined;
  "Gram-Project"?: string | undefined;
  PrepareEMARequestBody: PrepareEMARequestBody$Outbound;
};

/** @internal */
export const PrepareEMARequest$outboundSchema: z.ZodMiniType<
  PrepareEMARequest$Outbound,
  PrepareEMARequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
    gramKey: z.optional(z.string()),
    gramProject: z.optional(z.string()),
    prepareEMARequestBody: PrepareEMARequestBody$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      gramKey: "Gram-Key",
      gramProject: "Gram-Project",
      prepareEMARequestBody: "PrepareEMARequestBody",
    });
  }),
);

export function prepareEMARequestToJSON(
  prepareEMARequest: PrepareEMARequest,
): string {
  return JSON.stringify(
    PrepareEMARequest$outboundSchema.parse(prepareEMARequest),
  );
}
